import { createFileRoute } from '@tanstack/react-router'
import { FileSignature } from 'lucide-react'
import { z } from 'zod'
import { ContractDetailScreen } from '@/screens/improve/SCR-028-contract-detail'

export const Route = createFileRoute('/_app/w/$ws/contracts_/$contractId')({
  staticData: { screen: {"id":"SCR-028","title":"Contract detail","group":"Improve","perm":["contract.manage","approval.review"],"hidden":true,"description":"Parties, terms, versions, state and what it has allowed or blocked.", icon: FileSignature } },
  validateSearch: z.object({ tab: z.enum(['terms', 'versions', 'activity']).optional() }),
  component: ContractDetailScreen,
})
